'use client'
import { FormatDateWithConditions } from '@/shared/components/convertForm'
import CustomLink from '@/shared/components/customLink'
import MyImage from '@/shared/components/myImage'
import { S3_PREFIX } from '@/shared/constants'
import getStatus from '@/shared/hooks/useStatus'
import { dateCheck } from '@/shared/utils'
import { useMemo } from 'react'

export default function UpcomingMatchCard({ card }: any) {
  const { sStatusStr } = getStatus(card)

  const TeamA = useMemo(
    () => (
      <div className={`font-extrabold flex gap-2.5 items-center`}>
        <div className="align-middle min-w-[25px] object-cover overflow-hidden">
          <MyImage
            loadOnScroll
            src={
              card?.oTeamScoreA?.oTeam?.oImg?.sUrl
                ? `${S3_PREFIX}${card?.oTeamScoreA?.oTeam?.oImg?.sUrl}`
                : ''
            }
            className="aspect-square rounded-full"
            placeholderType="team"
            alt={card?.oTeamScoreA?.oTeam?.sAbbr}
            width={25}
            height={25}
            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
          />
        </div>
        <span className="ml-1.5 font-medium text-sm">
          {card?.oTeamScoreB?.oTeam?.sAbbr || card?.oTeamScoreB?.oTeam?.sTitle}
        </span>
      </div>
    ),
    [card]
  )

  const TeamB = useMemo(
    () => (
      <div className={`font-extrabold flex gap-2.5 items-center`}>
        <div className="align-middle">
          <MyImage
            loadOnScroll
            src={
              card?.oTeamScoreB?.oTeam?.oImg?.sUrl
                ? `${S3_PREFIX}${card?.oTeamScoreB?.oTeam?.oImg?.sUrl}`
                : ''
            }
            placeholderType="team"
            className="aspect-square rounded-full"
            alt={card?.oTeamScoreB?.oTeam?.sAbbr}
            width={25}
            height={25}
            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
          />
        </div>
        <span className="ml-1.5 font-medium text-sm">
          {card?.oTeamScoreB?.oTeam?.sAbbr || card?.oTeamScoreB?.oTeam?.sTitle}
        </span>
      </div>
    ),
    [card]
  )

  const handleClick = (sSlug: string) => {
    sSlug = sSlug?.replace('cricket/live-score', 'live-cricket-score')
    return `/${sSlug}`
  }
  return (
    <div className="relative border border-tabBorder rounded-xl">
      <CustomLink
        href={handleClick(card?.oSeo?.sSlug)}
        passHref
        className="h-full w-full absolute top-0 left-0 opacity-0 z-10"
        prefetch={false}
      >
        {card?.sTitle}
      </CustomLink>
      <div className="pb-0 pt-3 px-4 md:p-3.5 dark:md:bg-headersActive md:bg-[#FCFCFC] rounded-t-xl">
        <p className="flex items-center text-ellipsis whitespace-nowrap">
          <span className="text-xs text-[#999999] font-normal">Diamond Oval, Kimberley</span>
          {card?.sSubtitle && (
            <>
              <span className="h-1.5 w-1.5 rounded-full bg-[#353535] mx-2"></span>
              <span className="text-xs font-normal text-TextScoredCompplete ">
                {card?.sSubtitle}{' '}
              </span>
            </>
          )}
        </p>
      </div>
      <div className="grid grid-cols-12 px-4 pb-4 pt-3">
        <div className={`col-span-8 pr-2.5 md:pr-7`}>
          <div className="flex justify-between mb-3 md:mb-3.5 relative">
            {/* Team A */}
            {TeamA}
          </div>
          <div className="flex justify-between mb-0 relative">
            {/* Team B */}
            {TeamB}
          </div>
          {/* <div className=" hidden md:flex items-center gap-4">
            <CustomLink href="#" className="text-xs text-[#80878D]">
              Scorecard
            </CustomLink>
            <CustomLink href="#" className="text-xs text-[#80878D]">
              Fixture
            </CustomLink>
          </div> */}
        </div>
        {card?.dStartDate ? (
          <div className="col-span-4 flex items-center justify-center text-center">
            <div className={`text-ellipsis font-normal text-t-light text-xs overflow-hidden`}>
              {sStatusStr === 'scheduled' && (
                <FormatDateWithConditions utcDate={dateCheck(card?.dStartDate)} />
              )}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
